(function () {
  'use strict';

  /* Produktgalerie: Scroll-Snap-Track (natives Wischen), Vorschaubilder und Zähler bleiben synchron */
  var track = document.getElementById('gal-track');
  var thumbsBox = document.querySelector('.thumbs');
  var thumbs = document.querySelectorAll('.tbtn');
  var countEl = document.getElementById('stage-count');
  var slideCount = track ? track.children.length : 0;
  var current = 0, lock = null, lockTimer = null, ticking = false;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mark(i) {
    current = i;
    if (countEl) countEl.textContent = (i + 1) + ' / ' + slideCount;
    Array.prototype.forEach.call(thumbs, function (x, idx) {
      x.setAttribute('aria-pressed', String(idx === i));
    });
    var t = thumbs[i];
    if (t && thumbsBox && thumbsBox.scrollWidth > thumbsBox.clientWidth) {
      thumbsBox.scrollLeft = t.offsetLeft - (thumbsBox.clientWidth - t.offsetWidth) / 2;
    }
  }

  function goTo(i, animate) {
    if (!track || slideCount < 2) return;
    i = Math.max(0, Math.min(slideCount - 1, i));
    lock = i;
    clearTimeout(lockTimer);
    lockTimer = setTimeout(function () { lock = null; }, 900);
    mark(i);
    var left = i * track.clientWidth;
    if (typeof track.scrollTo === 'function') {
      track.scrollTo({ left: left, behavior: animate && !reduceMotion ? 'smooth' : 'auto' });
    } else {
      track.scrollLeft = left;
    }
  }

  if (track && slideCount > 1) {
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        if (lock !== null) {
          if (Math.abs(track.scrollLeft - lock * w) < 2) lock = null; else return;
        }
        var i = Math.round(track.scrollLeft / w);
        if (i !== current) mark(i);
      });
    }, { passive: true });
    /* Eigenes Wischen oder Scrollen hebt eine laufende Animation auf */
    track.addEventListener('touchstart', function () { lock = null; }, { passive: true });
    track.addEventListener('wheel', function () { lock = null; }, { passive: true });
    Array.prototype.forEach.call(thumbs, function (b, idx) {
      b.addEventListener('click', function () { goTo(idx, true); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1, true); }
    });
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { track.scrollLeft = current * track.clientWidth; }, 120);
    });
  }

  /* Kaufbox */
  var form = document.getElementById('buy');
  if (!form) return;

  var qtyInput = document.getElementById('qty-input');
  var dec = document.getElementById('qty-dec');
  var inc = document.getElementById('qty-inc');
  var price = document.getElementById('price');
  var wasWrap = document.getElementById('was-wrap');
  var was = document.getElementById('was');
  var badge = document.getElementById('badge');
  var lowest = document.getElementById('lowest');
  var lowestPrice = document.getElementById('lowest-price');
  var addBtn = document.getElementById('add-btn');
  var addLabel = document.getElementById('add-label');
  var ctaTotal = document.getElementById('cta-total');

  var variants = [];
  var currency = 'EUR';
  var data = document.getElementById('variants-json');
  if (data) {
    try {
      variants = JSON.parse(data.textContent);
      currency = data.getAttribute('data-currency') || 'EUR';
    } catch (e) { variants = []; }
  }

  var fmt;
  try {
    fmt = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: currency });
  } catch (e) {
    fmt = { format: function (n) { return n.toFixed(2); } };
  }
  function money(cents) { return fmt.format(cents / 100); }

  function qty() {
    var n = parseInt(qtyInput.value, 10);
    if (isNaN(n) || n < 1) return 1;
    return Math.min(99, n);
  }

  function currentVariant() {
    var field = form.querySelector('input[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');
    var id = field ? String(field.value) : '';
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) return variants[i];
    }
    return variants[0];
  }

  function render() {
    var v = currentVariant();
    if (!v) return;
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    price.textContent = money(v.price);
    if (wasWrap) wasWrap.hidden = !onSale;
    if (badge) badge.hidden = !onSale;
    if (lowest) lowest.hidden = !onSale;
    if (onSale) {
      was.textContent = money(v.compare_at_price);
      lowestPrice.textContent = money(v.compare_at_price);
      badge.textContent = 'Sale −' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %';
    }
    ctaTotal.textContent = money(v.price * qty());
    addBtn.disabled = !v.available;
    addLabel.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
  }

  dec.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() - 1); render(); });
  inc.addEventListener('click', function () { qtyInput.value = Math.min(99, qty() + 1); render(); });
  qtyInput.addEventListener('input', render);
  Array.prototype.forEach.call(form.querySelectorAll('input[name="id"]'), function (r) {
    r.addEventListener('change', render);
  });
  render();
})();
